import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {ReadersSingleVoyagesLazy} from "@containers/singleVoyage/readers/ReadersSingleVoyages.lazy";

const TrackableObjectsSingleVoyagesPage = () => {
	
	return (
		<PageLayout>
			<Suspense
				fallback={<SpinnerCustom/>}
			>
				<ReadersSingleVoyagesLazy/>
			</Suspense>
		</PageLayout>
	);
};

export default TrackableObjectsSingleVoyagesPage;
